import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Platform } from 'quasar';
import PageDrawer from 'src/components/@common/PageDrawer.vue';
import PageFooter from 'src/components/@common/PageFooter.vue';
import PageHeader from 'src/components/@common/PageHeader.vue';
import { ROUTES } from 'src/router/routes';
import { useAppStore } from 'src/store/appStore';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const appStore = useAppStore();

const drawer = ref(false);

// Add route names for which the Header should be hidden
const hideHeaderRoutes = ref<string[]>([
  ROUTES.PRELANDER,
  ROUTES.PRELANDER3,
  ROUTES.CONGRATULATIONS,
  ROUTES.UNINSTALL,
  ROUTES.ONBOARDING,
  ROUTES.DELETE_ACCOUNT,
]);
// Add route names for which the Footer should be hidden
const hideFooterRoutes = ref<string[]>([
  ROUTES.CONGRATULATIONS,
  ROUTES.UNINSTALL,
  ROUTES.ONBOARDING,
  ROUTES.DELETE_ACCOUNT,
]);
// Add route names for which the Logo on the left should be hidden
const hideLogoRoutes = ref<string[]>([ROUTES.HOME]);

const showHeader = computed(() => {
  return !hideHeaderRoutes.value.some(
    (definedRoute) => definedRoute === route.name
  );
});

const showLogo = computed(() => {
  return !hideLogoRoutes.value.some(
    (definedRoute) => definedRoute === route.name
  );
});

const showFooter = computed(() => {
  return (
    !hideFooterRoutes.value.some(
      (definedRoute) => definedRoute === route.name
    ) && !Platform.is.capacitor
  );
});

async function handleScrollTo(target: string) {
  await router.push('/');
  await nextTick();
  document.getElementById(target)?.scrollIntoView({
    behavior: 'auto',
    block: 'center',
    inline: 'center',
  });
  document.getElementById(`${target}_mobile`)?.scrollIntoView({
    behavior: 'auto',
  });
}

return (_ctx: any,_cache: any) => {
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "lhr lpR lfr",
    class: "overflow-hidden"
  }, {
    default: _withCtx(() => [
      (showHeader.value)
        ? (_openBlock(), _createBlock(_component_q_header, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(PageHeader, {
                "show-logo": showLogo.value,
                class: "animated fadeIn absolute-top",
                onScroll: handleScrollTo,
                onShowDrawer: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = true))
              }, null, 8, ["show-logo"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, { onScroll: handleScrollTo })
        ]),
        _: 1
      }),
      (showFooter.value)
        ? (_openBlock(), _createBlock(_component_q_footer, {
            key: 1,
            class: "bg-white"
          }, {
            default: _withCtx(() => [
              _createVNode(PageFooter, { onScroll: handleScrollTo })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(PageDrawer, {
        drawer: drawer.value,
        onCloseDrawer: _cache[1] || (_cache[1] = ($event: any) => (drawer.value = false)),
        onScroll: handleScrollTo
      }, null, 8, ["drawer"])
    ]),
    _: 1
  }))
}
}

})